import template from './dropdown-select.html';

const DIRECTIVE_NAME = DropdownSelect.DIRECTIVE_NAME = 'ktDropdownSelect';
export default function DropdownSelect() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: DropdownSelectController,
        controllerAs: '$ctrl',
        scope: {
            label: `@${DIRECTIVE_NAME}Label`,
            items: `=${DIRECTIVE_NAME}Items`,
            selectedItem: `=${DIRECTIVE_NAME}SelectedItem`,
            onChange: `&${DIRECTIVE_NAME}OnChange`,
        },
    };
}

export function DropdownSelectController() {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        selectItem,
        isItemSelected,
    });

    function isItemSelected(item) {
        return item === vm.selectedItem;
    }

    function selectItem(item) {
        if (item && vm.selectedItem !== item) {
            vm.selectedItem = item;
            if (vm.onChange) {
                vm.onChange({item});
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/dropdown-select/dropdown-select-component.js